module.exports = __webpack_public_path__ + "img/simple-marker.e61cd679.png";